<template>
  <div v-if="preloader === true">
    <template>
      <v-dialog v-model="preloader" hide-overlay persistent width="300">
        <v-progress-linear indeterminate></v-progress-linear>
      </v-dialog>
    </template>
  </div>
  <div class="interview-details-main-container page-container" :class="isMobile ? 'page-container--mobile-fixed' : 'ml-4'" v-else>
      <v-dialog
        v-model="recommandationFeedbackForm"
        persistent
        :width="isMobile ? '95%' : '1000px'"
        class="elevation-0"
      >
        <v-card class="recommendation-dialog-card">
          <div class="recommendation-dialog-scroll">
          <div class="text-h6">Recommendation* </div>
          <v-row class="mt-2">
            <v-col :cols="isMobile ? 12 : 8">
              <v-row>
                <v-col cols="6"><span class="text-body-2">System Recommendation </span></v-col><v-col cols="6"><v-chip
              :class="computedClass"
              
              >{{ finalRecommendation }}</v-chip
            ></v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col :cols="isMobile ? 12 : 8">
              <v-row class="d-flex align-center">
                <v-col cols="6"><span class="text-body-2"> Interviewer recommendation </span></v-col><v-col cols="6">
                    <span>
                      <v-select
                      :items="interviewerRecommendationOptions"
                      v-model="selectedinterviewerRecommendation"
                      label="Recommendation"
                      outlined
                      hide-details="auto"
                      :rules="[rules.required]"

                    ></v-select>
                </span>
                </v-col>
              </v-row>
            </v-col> 
          </v-row>
         
          <div class="pt-6">Remarks* </div>
          <v-textarea
          counter
          solo
          v-model="remarkValues"
          :rules="[rules.required, rules.counter]"
          maxlength="1000"
          class="rounded-xl mt-2 border-button"
        ></v-textarea>
            <div class="d-flex align-start pt-2">
            <v-checkbox v-model="isAgree" hide-details class="mt-0 pt-0 checkbox-top-align"></v-checkbox>
            <div class="text-caption checkbox-label-text">
              <span :class="isMobile && !showFullConsentText ? 'consent-text-clamp' : ''">
              By submitting this interview rating, I confirm that I have
              thoroughly evaluated the candidate's performance and provided a
              fair and accurate representation of their qualifications and
              suitability for the position. This rating will be considered as a
              part of the assessment process to inform the final decision on
              candidate selection.
              </span>
              <span
                v-if="isMobile"
                class="consent-toggle-link"
                @click="showFullConsentText = !showFullConsentText"
              >{{ showFullConsentText ? ' less' : ' more..' }}</span>
            </div>
          </div>
          </div>
          <v-card-actions class="px-6 pt-6 pb-3" :class="isMobile ? 'recommendation-dialog-actions' : ''">
            <v-spacer></v-spacer>
            <v-btn
              width="102px"
              height="48px"
              rounded
              outlined
              class="btn outline-btn pa-4"
              @click="recommandationFeedbackForm = false"
              >Cancel</v-btn
            >
            <v-btn
              width="102px"
              height="48px"
              rounded
              @click="submitInterviewFeedback()"
              :disabled="
              selectedinterviewerRecommendation == '' ||
                finalRecommendation == '' ||
                remarkValues == '' ||
                remarkValues?.length > 1000 ||
                isAgree == false
              "
              class="btn primary-btn pa-4"
              :loading="isbtnLoading"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
      v-model="videoDialog"
      :width="isMobile ? '100%' : '70%'"
      content-class="video-dialog-bottom-sheet"
      :transition="isMobile ? 'dialog-bottom-transition' : 'dialog-transition'"
      class="elevation-0"
      @click:outside="dialogClosed"
      @keydown.esc="dialogClosed"
    >
      <v-card color="background" class="video-dialog-card">
        <div class="video-dialog-scroll">
        <div>
          <v-icon @click="dialogClosed" class="pa-0 ma-0 float-right">mdi-close</v-icon>
        </div>
        <div  class="d-flex justify-center text-h6 pb-2">
          Recorded Video
        </div>
        <div class="recordViedoCard justify-space-between w:100 pa-2">
          <div class="recorded-video-topic">
              <div class="text-caption">RECOMMEMDED TOPIC</div>
              <div class="recorded-video-value">{{this.viewVideo?.topicName}}</div>
          </div>
          <div>
              <div class="text-caption">RECOMMEMDED DURATION</div>
              <div class="recorded-video-value">{{'12 - 15 Mins'}} </div>
          </div>
      </div>

      <div class="userVidDivForDemo bg-white d-flex justify-center mt-3" :style="{ height: videoHeight, width: '100%' }">
        <template v-if="viewVideo?.videoUrl">
          <video :key="viewVideo?.videoUrl" :poster="viewVideo?.thumbnailUrl" ref="video" controls width="100%" class="pt-2" style="max-height: 50vh;">
            <source :src="viewVideo?.videoUrl" type="video/mp4" />
          </video>
        </template>
        <template v-else>
          <div class="video-placeholder" :style="{ height: videoHeight, width: '100%' }">
            <span>No video available</span>
          </div>
        </template>
      </div>
      </div>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="resumeDownloadSnackbar" :timeout="3000">
      Downloaded {{ resumeDownloadedFileName }}
    </v-snackbar>
    <div class="top-panel" :style="isMobile ? 'padding-left: 0; height: 64px; padding-top: 16px;' : ''">
      <div class="d-flex align-center">
        <v-card-title class="pl-4" v-if="!isMobile">
          <p
            class="breadcrumb-text-unselected underline-on-hover cursor"
            @click="$router.back()"
          >
            Interviewee List
          </p>
          <v-icon
            class="breadcrumb-arrow-unselected"
            style="margin-top: 6px !important"
            >mdi-chevron-right</v-icon
          >

          <p class="breadcrumb-text" style="margin-top: 2px">Add Feedback</p>
          <v-icon class="breadcrumb-arrow" style="margin-top: 5px !important"
            >mdi-chevron-down</v-icon
          >
        </v-card-title>
        <UserNavMenu v-if="!isMobile"/>
      </div>
      <div
        class="my-0 w-100 d-flex align-center"
        :class="isMobile ? 'px-4' : 'qpad mx-6'"
      >
        <v-btn v-if="isMobile" icon large class="mr-1" :disabled="step == 2" @click="handleMobileBackClick">
          <v-icon size="28">mdi-arrow-left</v-icon>
        </v-btn>
        <div class="text-h6 " :class="!showTabs && !isMobile ? 'mt-minus' : ''" >{{ mobileHeaderTitle }}</div>
        <div class="d-flex align-center ml-auto interview-btn-container" v-if="this.showTabs">
           <v-btn v-if='step == 2' :disabled="disableBack" @click="showRatingUpdateView" class="btn outline-btn">Back</v-btn>
          <v-btn
            v-if="step == 2"
            depressed
            :disabled="disableNext"
            @click="goToDemoComparison"
            rounded          
            class="btn primary-btn d-none"
          >
            Next
          </v-btn> 
          <v-btn
            v-if="this.step == 2"
            depressed
            :disabled="disableSubmit"
            @click="openRecomendationFeedbackForm()"
            rounded          
            class="btn primary-btn"
          >
            Submit
          </v-btn> 
              <v-btn
            v-if="!isMobile && this.step == 1 && userData.interViewFeedback == undefined"
            depressed
            @click="startInterview"
            rounded
            class="btn tertiary-btn"
          >
            {{ isInProgress ? 'Resume': 'Start'}} Interview
          </v-btn>
        </div>
        <div class="d-flex align-center ml-auto interview-btn-container" v-else>

          <v-btn
            v-if="!isMobile && this.step == 1 && userData.interViewFeedback == undefined"
            depressed
            @click="startInterview"
            rounded
            class="btn tertiary-btn"
          >
            {{ isInProgress ? 'Resume': 'Start'}} Interview
          </v-btn>
        </div>
      </div>
    </div>

    <div v-if="isMobile && step == 1 && userData.interViewFeedback == undefined" class="mobile-start-interview-bar">
      <v-btn
        depressed
        block
        @click="startInterview"
        rounded
        class="btn tertiary-btn"
      >
        {{ isInProgress ? 'Resume': 'Start'}} Interview
      </v-btn>
    </div>

    <div >
      <v-container fluid :class="isMobile ? 'pa-0' : ''">
        <div class="d-flex interview-details-inner-container " :class="isMobile && userData.interViewFeedback != undefined && step == 1 ? 'mobile-feedback-stack' : ''" >
          <div
            v-if="isMobile && step == 2 && showMobileCandidateDrawer"
            class="mobile-candidate-drawer-backdrop"
            @click="showMobileCandidateDrawer = false"
          ></div>
          <aside
            v-if="!isMobile || step == 1 || step == 2"
            height="100%"
            elevation="0"
            color="#F7F7F3"
            class="pa-4 rounded-lg elevation-0 cardBorder"
            :class="[
              step == '2' && !showTabs  ? 'aside-scrollable-active-2' : step == '2' && showTabs ? 'aside-scrollable-active'  : 'scrollable-content-default',
              isMobile && userData.interViewFeedback != undefined && step == 1 ? 'mobile-stacked-panel' : '',
              isMobile && step == 1 ? 'mobile-full-width-card' : '',
              isMobile && userData.interViewFeedback == undefined && step == 1 ? 'mobile-top-panel-offset' : '',
              isMobile && step == 2 ? 'mobile-candidate-drawer' : '',
              isMobile && step == 2 && showMobileCandidateDrawer ? 'mobile-candidate-drawer--open' : ''
            ]"
          >
            <div  class="pos-rel">
              <div class="d-flex mb-5 fixed-panel top-0 align-center" :class="isMobile && step == 2 ? 'justify-space-between' : ''">
                <div class="d-flex align-center">
                  <div class="user-icon__container mr-4">
                    <img v-if="userData.userinfo?.proctoringPic"
                      :src="userData.userinfo?.proctoringPic"
                      class="rounded-xl w-100"
                    />
                    <img v-else
                      src="../assets/avtar.png"
                      class="rounded-xl w-100"
                    />
                  </div>
                  <div>
                    <p role-type="subtitle-4">
                      {{ this.userData.userinfo?.personalInfo.firstName | capitalizeFirst }}
                      {{ this.userData.userinfo?.personalInfo.lastName  | capitalizeFirst }}
                    </p>
                    <p role-type="subtitle-5 text-lowercase">
                      {{ this.userData.userinfo?.personalInfo?.contactInfo?.email }}
                    </p>
                    <p role-type="subtitle-5">
                      {{
                        this.userData.userinfo?.personalInfo?.contactInfo
                          ?.phoneNumber
                      }}
                    </p>
                  </div>
                </div>
                <v-btn
                  v-if="isMobile && step == 2"
                  icon
                  @click="showMobileCandidateDrawer = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
              <div class="scroller" :class="scrollerClass" >
                              <div class="resumeContainer">
                <div v-if="userData.userinfo?.resume_url" class="resumeBox">
                  <div class="font-12 pl-1 resume-file-name" :title="getResumeFileName(userData.userinfo?.resume_url)">{{ getResumeFileName(userData.userinfo?.resume_url) }}</div>
                  <v-btn icon class="flex-shrink-0" :loading="resumeDownloading" :disabled="resumeDownloading" @click="onResumeIconClick(userData.userinfo?.resume_url)">
                      <template v-slot:loader>
                        <v-progress-circular indeterminate size="20" width="2" color="primary"></v-progress-circular>
                      </template>
                      <img src="@/assets/view_1.svg" alt="Resume" style="width: 24px; height: 24px;" />
                  </v-btn>
                </div>
                <div v-else>
                  Resume Not Uploaded
                </div>
                
              </div>
                           
              <v-card class="pa-3 rounded-xl cardBorder interview-details-card">
             
                <div class="d-flex justify-space-between">
                  <div class="d-flex flex-column">
                    <p role-type="subtitle-5" class="mb-1">
                      Average Score
                    </p>
                    <p role-type="subtitle-4" class="font-weight-regular">
                      {{ this.avgScore }}/10 
                    </p>
                  </div>
                  <div class="d-flex flex-column">
                    <p role-type="subtitle-5" class="mb-1">Status</p>
                    <p role-type="subtitle-4" class="font-weight-regular truncate" :class="{ 'text-green': interviewStatus == 'Completed', 'text-orange': interviewStatus == 'Ongoing' }">
                     {{interviewStatus}}
                    </p>
                  </div>
                </div>
              </v-card>              
              <div class="interview-details-card">
                <div class="mb-2">
                  <p role-type="subtitle-5" class="mb-1">Job Role</p>
                  <v-tooltip bottom style="z-index: 999">
                                  <template v-slot:activator="{ on, attrs }">
                                      <p role-type="subtitle-4" v-bind="attrs" v-on="on" class="font-weight-regular truncate">{{userData.userinfo.teachingInterests.jobRole.HRIS_unique_role }}</p>
                                  </template>
                                  <span>{{userData.userinfo.teachingInterests.jobRole.HRIS_unique_role }}</span>
                                </v-tooltip>
                  
                </div>
                <div class="mb-2">
                  <p role-type="subtitle-5" class="mb-1">Level</p>
                  <v-tooltip bottom style="z-index: 999">
                    <template v-slot:activator="{ on, attrs }">
                        <p role-type="subtitle-4" v-bind="attrs" v-on="on" class="font-weight-regular truncate">{{ handleStringOrArray(userData.userinfo?.levels)}}</p>
                    </template>
                    <span>{{ handleStringOrArray(userData.userinfo?.levels)}}</span>
                  </v-tooltip>
                </div>
                <div class="mb-2" v-if="userData.departmentGroup == 'Academics' && handleStringOrArray(userData.userinfo.teachingInterests.boards) !== ''">
                  <p role-type="subtitle-5" class="mb-1">Board</p>
                  <v-tooltip bottom style="z-index: 999">
                    <template v-slot:activator="{ on, attrs }">
                        <p role-type="subtitle-4" v-bind="attrs" v-on="on" class="font-weight-regular truncate">{{handleStringOrArray(userData.userinfo.teachingInterests.boards)}}</p>
                    </template>
                    <span>{{ handleStringOrArray(userData.userinfo.teachingInterests.boards)}}</span>
                  </v-tooltip>
                </div>
                <div class="mb-2" v-if="userData.departmentGroup == 'Academics'">
                  <p role-type="subtitle-5" class="mb-1">Subject</p>
                  <v-tooltip bottom style="z-index: 999">
                    <template v-slot:activator="{ on, attrs }">
                        <p role-type="subtitle-4" v-bind="attrs" v-on="on" class="font-weight-regular truncate">{{handleStringOrArray(userData?.userinfo?.subjects)}}</p>
                    </template>
                    <span>   
                      <p role-type="subtitle-4" class="d-flex font-weight-regular truncate" small>
                      {{handleStringOrArray(userData?.userinfo?.subjects)}}
                      </p>
                    </span>
                  </v-tooltip>
                </div>
                <div>
                  <p role-type="subtitle-5" class="mb-1">Preferred Location</p>
                  <v-tooltip bottom style="z-index: 999">
                    <template v-slot:activator="{ on, attrs }">
                        <p role-type="subtitle-4" v-bind="attrs" v-on="on" class="font-weight-regular truncate">{{handleStringOrArray(userData.userinfo.teachingInterests.schools)}}</p>
                    </template>
                    <span>   
                      <p role-type="subtitle-4" class="d-flex font-weight-regular truncate" small>
                        {{handleStringOrArray(userData.userinfo.teachingInterests.schools)}}
                      </p>
                    </span>
                  </v-tooltip>
                </div>
              </div>
              <div class="interview-details-card">
                <div class="mb-2">
                  <p role-type="subtitle-5" class="mb-1">Total Experience</p>
                  <p role-type="subtitle-4" class="font-weight-regular">
                    {{ this.userData.candidateDetails.totalExperience.years }} {{ this.userData.candidateDetails.totalExperience.months  }}
                  </p>
                </div>
                <div class="mb-2">
                  <p role-type="subtitle-5" class="mb-1">Relevant Experience</p>
                  <p role-type="subtitle-4" class="font-weight-regular">
                    {{ this.userData.candidateDetails.relevantExperience.years }}  {{ this.userData.candidateDetails.relevantExperience.months }} 
                  </p>
                </div>
                <div class="mb-2">
                  <p role-type="subtitle-5" class="mb-1">Notice Period</p>
                  <p role-type="subtitle-4" class="font-weight-regular">
                    {{ this.userData.candidateDetails.noticePeriod }} days
                  </p>
                </div>
              </div>
              <div class="d-flex justify-space-between interview-details-card">
                <div class="d-flex flex-column">
                  <p role-type="subtitle-5" class="mb-1">Current CTC</p>
                  <p role-type="subtitle-4" class="font-weight-regular">
                    {{ this.userData.candidateDetails.currentCTC }} LPA
                  </p>
                </div>
                <div class="d-flex flex-column">
                  <p role-type="subtitle-5" class="mb-1">Expected CTC</p>
                  <p role-type="subtitle-4" class="font-weight-regular">
                    {{ this.userData.candidateDetails.expectedCTC }} LPA
                  </p>
                </div>
              </div>
              </div>
              <v-expansion-panels v-model="expandedPanelIndex" class="fixed-panel" :class="ratingScalePanelBottomClass">
                <v-expansion-panel elevation="0">
                  <v-expansion-panel-header>
                   <p class="text-subtitle-2">Rating Scale</p>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <div>
                    <v-row>
                          <v-col class="pa-1">
                            <div class="d-flex align-center">
                              <div class="color-box range-1 mr-2"></div>
                              <div v-if="this.ratingScale == 10" class="text-caption">1 & 2 - Weak</div>
                              <div v-else class="text-caption">1 - Weak</div>
                            </div>
                          </v-col>
                          <v-col  class="pa-1">
                            <div class="d-flex align-center">
                              <div class="color-box range-2 mr-2"></div>
                              <div v-if="this.ratingScale == 10" class="text-caption">3 & 4 - Basic</div>
                              <div v-else class="text-caption">2 - Basic</div>
                            </div>
                          </v-col>
                      </v-row>
                      <v-row>
                        <v-col  class="pa-1">
                          <div class="d-flex align-center">
                            <div class="color-box range-3 mr-2"></div>
                            <div v-if="this.ratingScale == 10" class="text-caption">5 & 6 - Competent</div>
                            <div v-else class="text-caption">3 - Competent</div>
                          </div>
                        </v-col>
                        <v-col class="pa-1">
                          <div class="d-flex align-center">
                            <div class="color-box range-4 mr-2"></div>
                            <div  v-if="this.ratingScale == 10" class="text-caption">7 & 8 - Strong</div>
                            <div v-else class="text-caption"> 4- Strong</div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pa-1">
                          <div class="d-flex align-center">
                            <div class="color-box range-5 mr-2"></div>
                            <div v-if="this.ratingScale == 10" class="text-caption">9 & 10 - Exceptional</div>
                            <div v-else class="text-caption">5 - Exceptional</div>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </aside>
          <section v-if="this.step == 3" class="pa-4 w-100 interview-rhs-container white ">
            <div class="d-flex justify-end mb-3">              
              <v-btn-toggle
                v-model="videoToggleIndex"
                rounded
                @change="changeTheVideo()"
              >
                <v-btn   v-for="(subject, index) in subjects" :key="index">{{ subject.subjectName }}</v-btn>
              
              </v-btn-toggle>                            
            </div>
            <div class="video-play-section d-flex align-center pr-4 rounded-lg mb-4">
              <div class="d-flex align-center">
                <div class="video-image-wrapper">
                  <video :key="currentVideo.videoUrl" 
                        :poster="this.currentVideo?.thumbnailUrl" 
                        ref="video"  
                        height="140px"
                        width="215px"
                        class="rounded-xl d-flex justify-align-center video-dimensions">
                      <source  :src="currentVideo.videoUrl" type="video/mp4">
                      </video>
                </div>
            
                <p role-type="subtitle-4" class="ml-12 font-weight-regular">{{ currentVideo.videoName }}</p>
              </div>
              <v-btn class="btn outline-btn ml-auto" @click="videoDialog = true">PLAY</v-btn>
            </div>
            <div class="">
              <div class="d-flex interview-score-container">
                <div class="interview-card">
                  <p role-type="body-3" class="font-weight-bold mb-4">System Score</p>                  
                  <v-card
                    width="100%"                    
                    elevation="0"                    
                    v-for="(data, index) in getSystemScore()"
                    :key="index"
                    class="rounded-xl elevation-0 cardBorder interview-inner-card gray-07 pa-4 mb-4"
                  >
                    <p class="d-flex justify-space-between" ><span role-type="body-4">{{ data.title }}</span> <span class="text-body-2">Score - {{ data.rating }}/10</span></p>
                    <p role-type="subtitle-5" class="gray--text mb-4">{{ data.description }}</p>
                    <div class="d-flex align-center">
                      <div
                        v-for="rate in 10"
                        :key="rate"
                        :class="selectRating(rate, data.rating)"
                      >
                        {{ rate }}
                      </div>
                    </div>
                  </v-card>
                </div>
                <v-divider class="gray-03 mx-4" vertical></v-divider>
                <div class="interview-card">
                  <p role-type="body-3" class="font-weight-bold mb-4">Your Score</p>                  
                  <v-card
                    width="100%"                    
                    elevation="0"                    
                    v-for="(data, index) in this.inPersonDemoFeedback"
                    :key="index"
                    class="rounded-xl elevation-0 cardBorder interview-inner-card gray-07 pa-4 mb-4"
                  >
                    <p role-type="body-4">{{ data.title }}</p>
                    <p role-type="subtitle-5" class="gray--text mb-4">{{ data.description }}</p>
                    <div class="d-flex align-center">
                      <div
                        v-for="rate in 10"
                        :key="rate"
                        :class="selectRating(rate, data.rating)"
                      >
                        {{ rate }}
                      </div>
                    </div>
                  </v-card>
                </div>                
              </div>
            </div>
          </section>
          <v-card
            v-if="!isMobile && this.step == 1 && userData.interViewFeedback == undefined && numberOfRounds.includes('demo')"
              color="#F7F7F3"
            width="100%"
            class="mx-6  rounded-lg elevation-0 cardBorder scrollable-content-default"
          >
            <div class="py-2 pl-6 text-subtitle-1 font-weight-bold">Demo Video</div>
            <div class="d-flex">
              <v-card
                v-for="(demoTest,index) in userData.demoVideoData"
                :key="index"
                color="#F7F7F3"
                width="240px"
                height="350px"          
                class="rounded-xl elevation-0 mx-2"
              >                
                <div class="interview-demo-card">
                  <div>
                    <video :key="demoTest?.videoUrl" ref="video"
                    width="100%"                   
                      class="rounded-xl d-flex justify-align-center">
                    <source  :src="demoTest?.videoUrl" :poster="demoTest?.thumbnailUrl" type="video/mp4">
                    </video>
                  </div>
                  <div class="text-caption pt-2 justify-align-center">
                    {{ demoTest?.subject }}
                  </div>
                  <div class="text-body-2 justify-align-center topic-name">
                    {{ demoTest?.topicName }}
                  </div>
                  <div class="d-flex justify-end mt-auto">
                    <v-btn
                      width="70px"
                      height="30px"
                      rounded
                      elevation="0"
                      @click="selectVideo(demoTest)"
                      class="btn outline-btn view-btn gray-02 elevation-0 text-body-2"
                    >
                      View
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </div>
          </v-card>
          <v-card v-else-if="!isMobile && step === 1 && !userData.interViewFeedback &&  numberOfRounds.includes('interview')"
          class="d-flex flex-column justify-center align-center mx-6 rounded-lg elevation-0 scrollable-content-default cardBorder w-100 interview-only-card">
            <v-img contain class="interview-only-banner" :src="waitForNextStep">
            </v-img>
            <div class="interview-feedback-subtitle">Click "Start Interview" button to begin filling out the interview feedback form</div>
          </v-card>
          <v-card
            v-if="this.step == 2"
            color="#F7F7F3"
            width="100%"
            class="rounded-lg elevation-0"
            :class="step == '2' && !showTabs ? 'scrollable-content-active' : 'scrollable-content-default'"
          >
          <div v-if="isMobile" class="d-flex align-center mobile-candidate-summary-card pa-3 mb-3 rounded-lg cardBorder">
            <div class="user-icon__container mr-3">
              <img v-if="userData.userinfo?.proctoringPic"
                :src="userData.userinfo?.proctoringPic"
                class="rounded-xl w-100"
              />
              <img v-else
                src="../assets/avtar.png"
                class="rounded-xl w-100"
              />
            </div>
            <div class="flex-grow-1 mobile-candidate-summary-info">
              <p role-type="subtitle-4" class="mb-0 text-truncate">
                {{ this.userData.userinfo?.personalInfo.firstName | capitalizeFirst }}
                {{ this.userData.userinfo?.personalInfo.lastName | capitalizeFirst }}
              </p>
              <p role-type="subtitle-5 text-lowercase" class="mb-0 text-truncate">
                {{ this.userData.userinfo?.personalInfo?.contactInfo?.email }}
              </p>
            </div>
            <v-btn outlined rounded class="mobile-candidate-nav-btn" color="#3F41D1" @click="showMobileCandidateDrawer = true">
              <v-icon color="#3F41D1">mdi-chevron-left</v-icon>
            </v-btn>
          </div>
          <div class="d-flex h-100">
            <InterviewScoreCard :isInProgress="isInProgress" :ratingScale='ratingScale' :showTabs="showTabs" :readOnly="false" :disableNext="disableNext" :interViewFeedbackData="interViewFeedback"  :tabsData="tabs" @onRatingChange="updateAvgScore($event)" @onCommentChange="updateComment($event)" @onRequestReady="updateRequestData($event)">
            </InterviewScoreCard>
          </div>
          <!-- <p>undo this v-if changs</p> -->
         
          <div class="d-flex h-100" v-if="showInterviewDetails && false">
              <div class="d-flex flex-column">
                <div
                  v-for="(data, index) in skills"
                  :key="index"
                  @click="selectSkill(data.skillName, index)"
                  :class="['commonColoredContainer', selectedSkill != data.skillName
                      ? findColor(data.skillName)
                      : findColorForSelected(data.skillName)
                  ]"
                >
                  <span class="spanContainer text-subtitle-2">{{
                    data.skillName
                  }}</span>
                </div>
              </div>
              <v-col class="pt-6 pl-4">
                <div v-if="selectedSkill == 'Core Skills'">
                  <v-col class="py-0">
                    <v-btn-toggle
                      rounded
                      mandatory
                      dense
                      class="subjectToggel mb-4"
                    >
                      <v-btn
                        v-for="(data, index) in this.subject"
                        :key="index"
                        width="125px"
                        @change="selectSubject(index)"
                        :class="
                          selectedSubjectIndex == index
                            ? 'custom-gray-text blue--text text-subtitle-2'
                            : 'blue--text text-subtitle-2'
                        "
                      >
                        {{ data.subjectName }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-card
                    width="100%"
                    height="20%"
                    elevation="0"
                    color="#F7F7F3"
                    v-for="(data, index) in this.subject[
                      this.selectedSubjectIndex
                    ]?.feedback"
                    :key="index"
                    class="rounded-xl elevation-0 cardBorder px-3 py-3 mb-4"
                  >
                    <div class="text-body-1">{{ data.title }}</div>
                    <div
                      class="text-subtitle-2 textGreyColor--text mb-5"
                    >
                      {{ data.description }}
                    </div>
                    <div class="d-flex align-center">
                      <div
                        v-for="rate in ratingScale"
                        :key="rate"
                        @click="selectRatingValue(rate, index)"
                        :class="selectRating(rate, data.rating)"
                      >
                        {{ rate }}
                      </div>
                    </div>
                  </v-card>
                </div>
                <div v-else id="myScroll" class="h-100">
                  <v-card
                    width="100%"
                    elevation="0"
                    color="#F7F7F3"
                    v-for="(data, index) in this.skills[this.selectedSkillIndex]
                      ?.feedback"
                    :key="index"
                    class="rounded-xl elevation-0 cardBorder px-3 py-3 mb-4"
                  >
                    <div class="text-body-1">{{ data.title }}</div>
                    <div
                      class="text-subtitle-2 textGreyColor--text mb-5"
                    >
                      {{ data.description }}
                    </div>
                    <div class="d-flex" id="ratingdsss">
                      <div
                        v-for="rate in 10"
                        :key="rate"
                        @click="selectRatingValueForSkills(rate, index)"
                        :class="selectRating(rate, data.rating)"
                      >
                        {{ rate }}
                      </div>
                    </div>
                  </v-card>
                </div>
              </v-col>
            </div>
          </v-card>
          <div
            class="d-flex flex-column w-100 scrollable-content-default scroller"
            :class="isMobile ? 'mobile-stacked-panel' : ''"
            v-if="userData.interViewFeedback != undefined && this.step == 1"
          >
            <v-card width="100%" class="rounded-xl elevation-0 cardBorder">        
                <v-container class="mt-4" v-if="isMobile">
                  <v-row align="center" no-gutters class="flex-nowrap">
                    <v-col cols="auto">
                      <img
                        src="../assets/VectorFeedback.svg"
                        class="rounded-xl interview-feedback-success-icon"
                      />
                    </v-col>
                    <v-col class="pl-4">
                      <div class="text-subtitle-1 font-weight-bold">
                        Interview feedback Submitted
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container class="mt-4" v-else>
                  <v-row justify="center">
                    <v-col cols="12" sm="5">
                      <img
                        src="../assets/interviewFeedbackSuccess.png"
                        class="rounded-xl d-flex justify-align-center"
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" sm="4">
                      <div
                        class="text-subtitle-1 d-flex justify-align-center font-weight-bold"
                      >
                        Interview feedback Submitted
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
                <div class="pl-4 text-subtitle-1 font-weight-bold" v-if="numberOfRounds.includes('demo')">Demo Video</div>
                <div class="d-flex" v-if="numberOfRounds.includes('demo')">
                  <v-card
                    v-for="data in this.userData.demoVideoData"
                    :key="data"
                    color="#F7F7F3"
                    width="240px"
                    class="rounded-xl elevation-0 mr-4"
                  >
                    <div class="interview-demo-card">
                      <div>
                        <video :key="data?.videoUrl" :poster="data?.thumbnailUrl" ref="video"
                        width="100%"                                  
                        class="rounded-xl d-flex justify-align-center">
                        <source  :src="data?.videoUrl" :poster="data?.thumbnailUrl" type="video/mp4">
                        </video>
                      </div>
                      <div class="text-caption pt-2 justify-align-center">
                        {{ data?.subject }}
                      </div>
                      <div class="text-body-2 justify-align-center topic-name">
                        {{ data?.topicName }}
                      </div>
                      <div class="d-flex justify-end mt-auto">
                        <v-btn
                          width="70px"
                          height="30px"
                          rounded
                          elevation="0"
                          @click="selectVideo(data)"
                          class="btn outline-btn view-btn gray-02 elevation-0 text-body-2"
                        >
                          View
                        </v-btn>
                      </div>
                    </div>
                  </v-card>
                </div>
             
              </v-card>
          </div>
        </div>
        <v-card v-if="this.step == 2 && !showTabs">
          <div class="d-flex justify-end pa-4" :class="isMobile && 'mobile-fixed-footer'">
            <v-btn @click="cancelFeedback" class="btn outline-btn mr-2">Cancel</v-btn>
          <v-btn
            depressed
            :disabled="disableSubmit"
            @click="openRecomendationFeedbackForm()"
            rounded
             class="btn tertiary-btn"
          >
            Proceed
          </v-btn>
          </div>
        </v-card>
      </v-container>
    </div>
  </div>
</template>
<script>
import CampaignController from "@/controllers/CampaignController";
import FeedbackController from "@/controllers/FeedbackController";
import AuthService from "../services/AuthService";
import "../styles.css";
import InterviewScoreCard from "@/components/InterviewScoreCard.vue";
import { cloneDeep } from "lodash";
import UserNavMenu from "@/components/UserNavMenu.vue";

export default {
  components: {InterviewScoreCard, UserNavMenu},
  name: "InterviewFeedbackForm",
  data() {
    return {
      feedbackV2: true,
      showTabs: true,
      ratingScale: 10,
      expandedPanelIndex:0,
      panel:0,
      toggle_exclusive: undefined,  
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 1000 || 'Maximum 1000 characters',
      },
      showInterviewDetails:true,
      preloader: true,
      selectedSkill: "Core Skills",
      isSumitButtonActive: false,
      isSubmitSubject: false,
      isSubmitSkills: false,
      selectedSkillIndex: 0,
      selectedSubjectIndex: 0,
      remarkValues: "",
      isAgree: false,
      finalRecommendation: "",
      avgScore: 0,
      skillAvg: 0,
      currentVideo:{},
      viewVideo:{},
      recommandationFeedbackForm: false,
      userData: {},
      isbtnLoading: false,
      recommendation: ["NOT RECOMMNDED", "HOLD", "STRONGLY RECOMMNDED"],
      isFeedbackSubmit: false,
      subAvg: 0,
      ratingValue: 0,
      pedagogyFeedback: [
        {
          title: "Creativity and Innovation*",
          description:
            "creativity and ability to generate innovative ideas or approaches within the subject domain",
          rating: 0,
        },
        {
          title: "Classroom Management*",
          description:
            "Inquire about the candidate's strategies for creating a positive and inclusive learning environment",
          rating: 0,
        },
        {
          title: "Student Engagement*",
          description:
            "Candidate's methods for promoting active student engagement and participation",
          rating: 0,
        },
        {
          title: "Differentiation*",
          description:
            "Addressing diverse needs and learning styles of the students",
          rating: 0,
        },
        {
          title: "Lesson Planning*",
          description:
            "Review the candidate's proficiency in developing comprehensive lesson plans that align with curriculum standards and learning objectives for the subject",
          rating: 0,
        },
      ],
      englishFeedback: [
        {
          title: "Verbal Communication*",
          description:
            "Evaluate the candidate's ability to articulate ideas clearly and effectively during verbal communication",
          rating: 0,
        },
        {
          title: "Clarity and Conciseness* ",
          description:
            "Assess the candidate's capacity to communicate information concisely and avoid ambiguity",
          rating: 0,
        },
        {
          title: "Active Listening*",
          description:
            "Inquire about the candidate's ability to actively listen to students, colleagues, and parents to understand their needs and concerns",
          rating: 0,
        },
        {
          title: "Nonverbal Communication*",
          description:
            "Discuss the candidate's awareness of and proficiency in using nonverbal cues to enhance communication i.e. Body Language, Expression, Facial Expression etc",
          rating: 0,
        },
        {
          title: "Empathy and Empathetic Communication*",
          description:
            "Assess the candidate's capacity to empathize with students, colleagues, and parents and communicate in a supportive and compassionate manner",
          rating: 0,
        },
        {
          title: "Collaborative Communication*",
          description:
            "Inquire about the candidate's ability to collaborate effectively with colleagues, administrators, and other stakeholders",
          rating: 0,
        },
      ],
      inPersonDemoFeedback:[{
        title: "Confidence*",
        description: " Assess the teacher's confidence and composure during the demonstration.",
        rating:0,
      },{
        title: "Behaviour*",
        description: "Assess how the teacher interacts, behaves, and engages with students.",
        rating:0 
      },{
        title: "Fluency*",
        description:"Assess the teacher's ability to communicate ideas clearly and smoothly.",
        rating:0
      },{
        title:"Knowledge*",
        description:"Evaluate subject knowledge, concept introduction, and use of examples, metaphors, and analogies",
        rating:0
      },{
        title:"Use of teaching aids/resources*",
        description:"Assess how effectively the candidate utilizes teaching materials to enhance learning.",
        rating:0
      },{
        title:"Techniques and Methodology*",
        description:"Evaluate the teaching strategies used to engage students.",
        rating:0
      },{
        title:"Classroom Management*",
        description:"Observe how the candidate maintains discipline and handles student behavior.",
        rating:0
      },{
        title:"Demonstrates enthusiasm for teaching and learning*",
        description:"Determine if the candidate exhibits passion and energy while teaching.",
        rating:0
      },{
        title:"Time Management*",
        description:"Assess how efficiently the candidate manages class time and activities.",
        rating:0
      },{
        title:"Atmosphere of the classroom is participative*",
        description:"Check if the candidate encourages student engagement and interaction.",
        rating:0
      },{
        title:"Moves around the classroom with ease and interacts with students*",
        description:"Observe how actively the candidate engages with students while teaching.",
        rating:0
      },{
        title:"Summarizes the lesson/subject matter at the end of the class*",
        description:"Assess how effectively the candidate reinforces key points and wraps up the lesson.",
        rating:0
      }
    ],
    systemDemoFeedback: [],
      computerFeedback: [
        {
          title: "Basic Computer Proficiency*",
          description:
            "Assess the candidate's familiarity with basic computer operations and software applications",
          rating: 0,
        },
        {
          title: "Educational Technology Tools*",
          description:
            "Inquire about the candidate's knowledge and experience with educational technology tools and platforms",
          rating: 0,
        },
        {
          title: "Digital Content Creation*",
          description:
            "Evaluate the candidate's ability to create digital content for instructional purposes, such as presentations, videos, and interactive multimedia resources",
          rating: 0,
        },
        {
          title: "Internet Research Skills",
          description:
            "Discuss the candidate's proficiency in conducting internet research and evaluating online resources",
          rating: 0,
        },
        {
          title: "Learning Management Systems (LMS)*",
          description:
            "Inquire about the candidate's experience with learning management systems for organizing course materials, assignments, and communication with students",
          rating: 0,
        },
        {
          title: "Data Management and Analysis*",
          description:
            "Assess the candidate's ability to collect, manage, and analyze data using digital tools and software",
          rating: 0,
        },
      ],
      psychometryFeedback: [
        {
          title: "Professional Ethics and Integrity*",
          description:
            "Assess the candidate's commitment to ethical standards and integrity in their interactions with students, colleagues, and parents",
          rating: 0,
        },
        {
          title: "Self-awareness*",
          description:
            "Ask the candidate about their process of self-reflection and how they assess their teaching practices",
          rating: 0,
        },
        {
          title: "Empathy and Understanding*",
          description:
            "Inquire about the candidate's ability to empathize with students perspectives and understand their individual needs and challenges",
          rating: 0,
        },
        {
          title: "Motivation and Enthusiasm*",
          description:
            "Assess the candidate's level of motivation and enthusiasm for teaching and their ability to inspire and engage students",
          rating: 0,
        },
        {
          title: "Interpersonal Skills*",
          description:
            "Assess the candidate's capacity to build positive relationships with students, colleagues, parents, and other stakeholders",
          rating: 0,
        },
        {
          title: "Emotional Intelligence*",
          description:
            "Inquire about the candidate's ability to recognize, understand, and manage their own emotions, as well as those of their students",
          rating: 0,
        },
        {
          title: "Leadership*",
          description:
            "Envisioning the future and setting directions. Aligning structure, systems and people to the vision / goal. Leading through example and motivating teams to achieve goals",
          rating: 0,
        },
      ],
      subject: [],
      skills: [],
      videoDialog:false,
      waitForNextStep: require('@/assets/waitForNextStep.svg'),
      userId: "",
      slotId: "",
      timeSlotId: "",
      intervieweremail: "",
      campaignId: "",
      showDemoDetails:false,
      comment: '',
      recomendationScoreMap: {
        40 : "Not Recommended",
        60  : "On Hold",
        101  : "Recommended"
      },
      tabs:{
        headers: [{name: 'Core Skills',   totalfeedBackcount: 0,
        ScoredFeedbackCount: 0}],
        data:[]
      },
      interViewFeedback:[],
      disableNextBtn:true,
      showSubmit: false,
      showNext: true,
      disableNext: true,
      disableBack:true,
      showDemoComparision: false,
      videoToggleIndex:0,
      showBack: true,
      step:1,
      interviewStatus: "Ongoing",
      interviewerRecommendationOptions:[],
      selectedinterviewerRecommendation: '',
      round: 1,
      subjects: [],
      blankFeedbackForm: {},
      currentTestRoundIndex: 0,
      numberOfRounds: [],
      isInProgress:false,
      resumeFeedback: {},
      autoSaveTimer: null,
      lastAutoSaveTime: 0,
      // attendance acknowledgement checkbox removed; submitting feedback implies participation
      isInterviewAttendee: true,
      showFullConsentText: false,
      showMobileCandidateDrawer: false,
      savedScrollY: 0,
      resumeDownloading: false,
      resumeDownloadSnackbar: false,
      resumeDownloadedFileName: ''
    };
  },
  computed:{
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    totalFeedbackGivenCount() {
      return (this.interViewFeedback || []).filter((item) => Number(item?.rating) > 0).length;
    },
    totalFeedbackRequiredCount() {
      return (this.interViewFeedback || []).length;
    },
    mobileHeaderTitle() {
      if (this.isMobile && this.step == 2) {
        return `Feedback (${this.totalFeedbackGivenCount}/${this.totalFeedbackRequiredCount})`;
      }
      if (this.isMobile && this.step == 1) {
        return 'Feedback';
      }
      return 'Candidate Details';
    },
    scrollerClass() {
      if (this.isMobile && this.step == 1 && this.userData.interViewFeedback == undefined) {
        return this.expandedPanelIndex === 0 ? 'mid-scroll-1-mobile' : 'mid-scroll-2-mobile';
      }
      if (this.showTabs) {
        return this.expandedPanelIndex === 0 ? 'mid-scroll-1' : 'mid-scroll-2';
      }
      if (this.step === 2) {
        return this.expandedPanelIndex === 0 ? 'mid-scroll-1-new' : 'mid-scroll-2-new';
      }
      return this.expandedPanelIndex === 0 ? 'mid-scroll-1' : 'mid-scroll-2';
    },
    ratingScalePanelBottomClass() {
      if (this.isMobile && this.step == 1 && this.userData.interViewFeedback == undefined) {
        return 'bottom-mobile';
      }
      return this.step == 2 && !this.showTabs ? 'bottom-100' : 'bottom-10';
    },
    computedClass() {
    if (this.finalRecommendation === "Not Recommended") return "not-recommended";
    if (this.finalRecommendation === "On Hold") return "moderately-recommended";
    if (this.finalRecommendation === "Recommended") return "strongly-recommended";
    return ""; // Default: no class if the status doesn't match
  },
  isProduction() {
      const localStorageValue = localStorage.getItem('DISABLE_INTERVIEW_RESTRICTION');
      if (localStorageValue === 'false') {
        return true;
      }
      return process.env.VUE_APP_IS_PRODUCTION === "true";
  },
  disableSubmit() {
    return !this.hasCompletedAllRequiredRatings;
  },
  hasCompletedAllRequiredRatings() {
    if (!this.showTabs) {
      return Array.isArray(this.interViewFeedback)
        && this.interViewFeedback.length > 0
        && !this.interViewFeedback.some((item) => (item?.isRequired !== false) && Number(item?.rating) <= 0);
    }

    const hasSubjects = Array.isArray(this.subjects) && this.subjects.length > 0;
    const hasSkills = Array.isArray(this.skills);

    if (!hasSubjects || !hasSkills) {
      return false;
    }

    const hasIncompleteSubjectRatings = this.subjects.some((subject) =>
      subject?.feedback?.some((item) => item?.title?.includes('*') && Number(item?.rating) <= 0)
    );

    const hasIncompleteSkillRatings = this.skills.some((skill) =>
      skill?.feedback?.some((item) => item?.title?.includes('*') && Number(item?.rating) <= 0)
    );

    return !hasIncompleteSubjectRatings && !hasIncompleteSkillRatings;
  },
  videoHeight() {
      return '50vh'; // Adjust height as necessary to keep video and placeholder the same size
    }
  },
  watch: {
    videoDialog(val) {
      if (val) {
        this.resetVideoToStart();
      }
    },
  },
 async mounted() {
    if (this.isMobile) {
      this.lockBodyScroll();
    }
    this.showTabs = !this.feedbackV2;
    this.isInProgress = this.$route.query?.isInProgress == 'true';
    this.interviewerRecommendationOptions = Object.values(this.recomendationScoreMap)
    this.userId = this.$route.query.userId;
    this.slotId = this.$route.query.slotId;
    this.timeSlotId = this.$route.query.timeSlotId;
    this.intervieweremail = this.$route.query.intervieweremail;
    this.campaignId = this.$route.query.campaignId;
    this.round = this.$route.query.round || 1
    const {isActive,slotOpenTime} = this.isInterviewActive();
    if(!isActive) {
      return this.$router.push("/interview-notactive?data=" + btoa(slotOpenTime.toISOString()));
    };
    await this.getBlankFeedbackForm()
    if(this.isInProgress){
      await this.retriveInterViewFeedback()
      this.populateResumeData()
    }
    await this.getInterInfo(
      this.intervieweremail,
      this.userId,
      this.slotId,
      this.timeSlotId,
      this.campaignId
    );
  },
  methods: {
     populateResumeData(){
      this.selectedinterviewerRecommendation = this.resumeFeedback?.interviewerRecommendation || ''
      this.remarkValues = this.resumeFeedback.remark || ''
    
      setTimeout(()=>{
        this.avgScore = this.resumeFeedback.avgScore;
      }, 2000)
    },
    handleStringOrArray(data){
      let nullArr = ['', null, undefined, [], {}]
      if(nullArr.includes(data)){
        return ''
      }else if (typeof data == 'string'){
        return data 
      } else if (Array.isArray(data)){
        return data.join(',')
      }

    },
  async  getBlankFeedbackForm(){
       let  query = "?userId=" + this.userId + "&campaignId=" + this.campaignId;
      const response = await FeedbackController.getFeedbackFormData(query)
      if(response.data?.flag){
        this.feedbackV2 = response.data.feedbackV2
         this.showTabs = !this.feedbackV2;
         this.tabs = {
          headers: [{ name: 'Core Skills', totalfeedBackcount: 0, ScoredFeedbackCount: 0 }],
          data: []
         };
         this.subjects = [];
         this.skills = [];
         if (this.feedbackV2) {
          this.blankFeedbackForm = response.data.data?.competencies || [];
          this.interViewFeedback = this.blankFeedbackForm.map((item) => ({
            ...item,
            rating: item.rating || '',
            isRequired: item.isRequired !== false,
          }));
          this.ratingScale = response.data?.scale || 5;
         } else {
          this.blankFeedbackForm = response.data.data || [];
          this.interViewFeedback = [];
          this.ratingScale = response.data?.scale || 10;
         }
         this.currentTestRoundIndex = response.data.currentTestRoundIndex;
         this.numberOfRounds = response.data.numberOfRounds
         if(!this.numberOfRounds.includes('demo')){
             this.blankFeedbackForm =  this.blankFeedbackForm.filter((item)=> item.name !== 'Inperson Demo' && item.name !== 'systemDemoFeedback')
             if (this.feedbackV2) {
              this.interViewFeedback = this.interViewFeedback.filter((item) => item.name !== 'Inperson Demo' && item.name !== 'systemDemoFeedback');
             }
         }
      }
    },
    changeTheVideo(){
      let subjectName = this.subjects[this.videoToggleIndex].subjectName
      this.currentVideo  = this.userData.demoVideoData.filter((item)=>item.subject == subjectName)[0]
    },
      goToDemoComparison(){
      this.showDemoComparision = true
      this.showSubmit = true
      this.showNext = false
      this.disableBack = false
      this.step = 3
    },
    startInterview() {
      this.showInterviewDetails = true;
      this.showSubmit = false
      this.showNext = true
      this.showBack = true
      this.step = 2
      this.interviewStatus = "Ongoing"

    },
    showRatingUpdateView(){
      this.showInterviewDetails = true;
      this.showSubmit = false
      this.showNext = true
      this.showDemoComparision = false
      this.disableBack = true
      this.step = 2
      this.interviewStatus = "Ongoing"
    },
    cancelFeedback(){
      this.step = 1;

    },
    dialogClosed() {
      this.pauseVideo();
      this.videoDialog = false;
    },
    pauseVideo() {
      if (this.$refs.video) {
        this.$refs.video.pause();
      }
    },
    async getSubject() {
      if (!this.showTabs) {
        return;
      }
      let innerData =[]
      this.tabs.headers[0].totalfeedBackcount = this.userData.userinfo?.subjects?.length * 3
      let coreSkillCb = ({name})=> name == "coreSkillFeedback"
      let coreSkillIndex = this.blankFeedbackForm.findIndex(coreSkillCb)
      if(this.isInProgress){
        let ScoredFeedbackCount = 0
        this.resumeFeedback.subjects?.forEach((sub)=>{
          innerData.push({subName: sub.subjectName, data: sub.feedback});
          this.subjects.push({
            subjectName: sub.subjectName, 
            feedback: sub.feedback
          })
          ScoredFeedbackCount += sub.feedback.filter((fee)=>  fee.rating > 0).length
        })
         this.tabs.headers[0].ScoredFeedbackCount = ScoredFeedbackCount
      }else {
        this.userData.userinfo?.subjects?.forEach((sub) => {
          innerData.push({subName: sub, data: cloneDeep(this.blankFeedbackForm[coreSkillIndex].data)})
          this.subjects.push({
            subjectName: sub,
            feedback:cloneDeep(this.blankFeedbackForm[coreSkillIndex].data)  
          });
        });
      }
      this.tabs.data.push(innerData)
    },
    autoSave() {
      
      // Clear any pending throttled call
      if (this.autoSaveTimer) {
        clearTimeout(this.autoSaveTimer);
      }

      const now = Date.now();
      const timeSinceLastSave = now - this.lastAutoSaveTime;
      const throttleDelay = 5000; // 5 seconds

      if (timeSinceLastSave >= throttleDelay) {
        // Enough time has passed, execute immediately
        this.executeAutoSave();
      } else {
        // Schedule for later
        const remainingTime = throttleDelay - timeSinceLastSave;
        this.autoSaveTimer = setTimeout(() => {
          this.executeAutoSave();
        }, remainingTime);
      }
    },
    
  async executeAutoSave() {
      this.$router.replace({
      query: {  ...this.$route.query, isInProgress: 'true' }
    })
      this.lastAutoSaveTime = Date.now();
      
      let payload = {
        emailId: this.intervieweremail,
        slotId: this.slotId, 
        timeSlotId: this.timeSlotId, 
        userId: this.userId,
        campaignId: this.campaignId,
        currentTestRoundIndex: this.currentTestRoundIndex,
        data: {
        subjects: this.showTabs ? this.subjects : [],
        skills: this.showTabs ? this.skills : [],
        newFeedBack: this.showTabs ? [] : this.interViewFeedback,
        avgScore: this.avgScore,
        recommendation: this.finalRecommendation,
        interviewerRecommendation: this.selectedinterviewerRecommendation,
        remark: this.remarkValues,
        interviewerEmail: this.intervieweremail,
        round: this.round,
        comment: this.comment || 'NA',
        },
      };
      
      try {
        const res = await CampaignController.autoSaveInterviewFeedback(payload);
        console.log(res);
      } catch(error) {
        console.log(error);
      }
    },
    getSkills() {
      if (!this.showTabs) {
        return;
      }
      let coreSkillCb = ({name})=> name == "coreSkillFeedback"
      let coreSkillIndex = this.blankFeedbackForm.findIndex(coreSkillCb)
  
     
      if(this.isInProgress){
        this.resumeFeedback.skills?.forEach((sub)=>{
          if(sub.skillName == 'systemDemoFeedback'){
            this.systemDemoFeedback = sub.feedback
          }else {
             this.tabs.data.push({subName: sub.skillName, data: sub.feedback})
            this.tabs.headers.push({name: sub.skillName, totalfeedBackcount: sub.feedback?.length,
            ScoredFeedbackCount: sub.feedback.filter((fee)=>  fee.rating > 0).length})
        
          this.skills.push({skillName:sub.skillName, feedback:sub.feedback})
          }
        })
      }else {
      let skills = cloneDeep(this.blankFeedbackForm)
      skills.splice(coreSkillIndex, 1)
        skills.forEach((sub)=>{
        if(sub.name =='systemDemoFeedback'){
          this.systemDemoFeedback = sub.data
        }else{
          this.tabs.data.push({subName: sub.name, data: sub.data})
          this.tabs.headers.push({name: sub.name, totalfeedBackcount: sub.data?.length,
            ScoredFeedbackCount: 0})
        
          this.skills.push({skillName:sub.name, feedback:sub.data})
        }
      })
      }

      // for(let sub in skills){
      //   if(sub =='systemDemoFeedback'){
      //     this.systemDemoFeedback = skills[sub]
      //   }else{
      //     this.tabs.data.push({subName: sub, data: skills[sub]})
      //     this.tabs.headers.push({name: sub, totalfeedBackcount: skills[sub]?.length,
      //       ScoredFeedbackCount: 0})
        
      //     this.skills.push({skillName:sub, feedback:skills[sub]})
      //   }
    
      // }

    },
 
    getSystemScore(){
      let subjectName = this.subjects[this.videoToggleIndex].subjectName
      this.currentVideo  = this.userData.demoVideoData.filter((item)=>{
        return item.subject == subjectName})[0];
      if(this.systemDemoFeedback.length > 0){
        let feedbackCopy = this.systemDemoFeedback;
        let demoScores = this.userData.demoScores[this.userData.demoScores.findIndex((item)=> item.name == subjectName)]
        feedbackCopy[0].rating  = demoScores?.confidenceLevel
        feedbackCopy[1].rating = demoScores?.behaviorlLevel
        feedbackCopy[2].rating = demoScores?.fluencyLevel
        feedbackCopy[3].rating = demoScores?.knowledgeLevel
        return feedbackCopy;
      } 
      return []
    }, 

    async avgForSubject() {
      this.isSubmitSubject = true;
      var subjectAvg = 0;
      this.subject?.forEach((sub) => {
        var currSubAvg = 0;
        sub?.feedback?.forEach((feed) => {
          currSubAvg = currSubAvg + feed.rating;
          if (feed.rating == 0) {
            this.isSubmitSubject = false;
          }
        });
        var currSubAvg = currSubAvg / sub?.feedback?.length;
        subjectAvg = subjectAvg + currSubAvg;
        if (this.isSubmitSkills && this.isSubmitSubject) {
          this.isSumitButtonActive = true;
        }
      });
      this.subAvg = subjectAvg / this.subject?.length;
      if(this.skills?.length > 1){
        this.avgScore = ((this.subAvg + this.skillAvg) / 2).toFixed(2);
        if (isNaN(this.avgScore)) {
          this.avgScore = 0.00;
        }
      }else{
        this.avgScore = this.subAvg.toFixed(2);
        if (isNaN(this.avgScore)) {
          this.avgScore = 0.00;
        }
      }
    },
    async avgForSkills() {
      this.isSubmitSkills = true;
      var skillAvg = 0;
      var length = 0;
      var isHaveCoreSkill = false;
      this.skills?.forEach((sub) => {
        if (sub.skillName != "Core Skills") {
          var currSkillAvg = 0;
          sub?.feedback?.forEach((feed) => {
            currSkillAvg = currSkillAvg + feed.rating;
            if (feed.rating == 0) {
              this.isSubmitSkills = false;
            }
          });
          var currSkillAvg = currSkillAvg / sub?.feedback?.length;
          skillAvg = skillAvg + currSkillAvg;
        } else {
          isHaveCoreSkill = true;
        }
      });
      if (isHaveCoreSkill) {
        if (this.isSubmitSkills && this.isSubmitSubject) {
          this.isSumitButtonActive = true;
        }
        length = this.skills?.length - 1;
        this.skillAvg = skillAvg / length;
        this.avgScore = ((this.subAvg + this.skillAvg) / 2).toFixed(2);
        if (isNaN(this.avgScore)) {
          this.avgScore = 0.00;
        }
      } else {
        this.isSumitButtonActive = this.isSubmitSkills;
        length = this.skills?.length;
        this.skillAvg = skillAvg / length;
        this.avgScore = (this.subAvg + this.skillAvg).toFixed(2);
        if (isNaN(this.avgScore)) {
          this.avgScore = 0.00;
        }
      }
    },
    updateAvgScore(data){
      if(this.showTabs){
          this.subjects = data.feedback.subjects
          this.skills = data.feedback.skills
      }else{
        this.interViewFeedback = data.feedback
      }
      this.avgScore = data.avg.toFixed(2)
      this.autoSave()
    },
    updateComment(comment) {
      this.comment = comment
    },
    selectSkill(skillName, index) {
      this.selectedSkill = skillName;
      this.selectedSkillIndex = index;
    },
    selectSubject(index) {
      this.selectedSubjectIndex = index;
    },
    selectRatingValue(val, index) {
      this.subject[this.selectedSubjectIndex].feedback[index].rating = val;
      this.avgForSubject();
    },
    selectRatingValueForSkills(val, index) {
      this.skills[this.selectedSkillIndex].feedback[index].rating = val;
      this.avgForSkills();
    },
    convertToQueryString(payload) {
      return Object.entries(payload)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    },
    async retriveInterViewFeedback(){
       let query  = '?'
      let payload = {
        emailId: this.intervieweremail,
        slotId: this.slotId, 
        timeSlotId: `${this.timeSlotId}`, 
        userId: this.userId,
        campaignId:this.campaignId,
        currentTestRoundIndex: this.currentTestRoundIndex
      }
      query += this.convertToQueryString(payload)
      const res = await CampaignController.retriveInterViewFeedback(query)   
      const savedData = res.data.result.data
      if (this.showTabs) {
        this.resumeFeedback = savedData
      } else {
        this.resumeFeedback = savedData || {}
        this.interViewFeedback = savedData?.newFeedBack || []
      }

    },
    findColor(value) {
      var colors = "";
      switch (value) {
        case "Core Skills":
          return "containerCoreSkillLite cursor";
          break;
        case "Pedagogy":
          return "containerPedagigyLite cursor";
          break;
        case "Communication Skills":
          return "containerEnglishLite cursor";
          break;
        case "Digital Literacy":
          return "containerComputerLite cursor";
          break;
        case "Psychometry":
          return "containerPsychrometricLite cursor";
          break;
        default:
          return "containerPsychrometricLite cursor";
      }
    },
    selectRating(rating, ratingValue) {
      switch (rating) {
        case 1:
          return ratingValue >= 1
            ? "interviewRate1 white--text"
            : "interviewRate";
          break;
        case 2:
          return ratingValue >= 2
            ? "interviewRate2"
            : "interviewRate";
          break;
        case 3:
          return ratingValue >= 3
            ? "interviewRate3"
            : "interviewRate";
          break;
        case 4:
          return ratingValue >= 4
            ? "interviewRate4"
            : "interviewRate";
          break;
        case 5:
          return ratingValue >= 5
            ? "interviewRate5"
            : "interviewRate";
          break;
        case 6:
          return ratingValue >= 6
            ? "interviewRate6"
            : "interviewRate";
          break;
        case 7:
          return ratingValue >= 7
            ? "interviewRate7"
            : "interviewRate";
          break;
        case 8:
          return ratingValue >= 8
            ? "interviewRate8"
            : "interviewRate";
          break;
        case 9:
          return ratingValue >= 9
            ? "interviewRate9"
            : "interviewRate";
          break;
        case 10:
          return ratingValue >= 10
            ? "interviewRate10"
            : "interviewRate";
          break;
        default:
          return "interviewRate";
          break;
      }
      
    },
    findColorForSelected(value) {
      switch (value) {
        case "Core Skills":
          return "containerCoreSkillHard active-skill";
          break;
        case "Pedagogy":
          return "containerPedagigyHard active-skill";
          break;
        case "Communication Skills":
          return "containerEnglishHard active-skill";
          break;
        case "Digital Literacy":
          return "containerComputerHard active-skill";
          break;
        case "Psychometry":
          return "containerPsychrometricHard active-skill";
          break;
        default:
          return "containerPsychrometricHard active-skill";
      }
    },
    updateRequestData(data){
      this.disableNext = false;
      if (this.showTabs) {
        this.subjects =  data.subjects;
        this.skills = data.skills
      } else {
        this.interViewFeedback = data
      }
    },
    async submitInterviewFeedback() {
      this.isbtnLoading = true;
      const payloadData = this.showTabs ? {
        subjects: this.subjects,
        skills: this.skills,
        avgScore: this.avgScore,
        recommendation: this.finalRecommendation,
        interviewerRecommendation: this.selectedinterviewerRecommendation,
        remark: this.remarkValues,
        interviewerEmail : this.intervieweremail,
        round: this.round,
        comment: this.comment || 'NA',
      } : {
        avgScore: this.avgScore,
        recommendation: this.finalRecommendation,
        interviewerRecommendation: this.selectedinterviewerRecommendation,
        newFeedBack:this.interViewFeedback,
        remark: this.remarkValues,
        interviewerEmail : this.intervieweremail,
        round: this.round,
        comment: this.comment || 'NA',
      };
      try {
        var res = await CampaignController.submitInterViewFeedback(
          this.intervieweremail,
          this.slotId,
          this.timeSlotId,
          payloadData,
          this.userId,
          this.campaignId,
          this.currentTestRoundIndex + 1
        );
        if (res.data.flag) {
          this.showDemoComparision = false;
          this.showBack = false;
          this.showSubmit = false;
          this.interviewStatus = 'Completed'
          console.log("success");
         await this.getInterInfo(
            this.intervieweremail,
            this.userId,
            this.slotId,
            this.timeSlotId,
            this.campaignId
          );
          this.step = 1; 
          this.isbtnLoading = false;
          this.isFeedbackSubmit = true;
          this.showDemoDetails = true;
          this.recommandationFeedbackForm = false;
          
        }
      } catch (error) {
        alert(error);
        this.isbtnLoading = false;
      }
    },
    async getInterInfo(email, userId, slotId, timeSlotId, camapaignId) {
      try {
        var data = await CampaignController.getInterViewUserInfo(
          email,
          slotId,
          timeSlotId,
          userId,
          camapaignId
        );
        if (data.data.flag) {
          this.userData = data.data.data;
          if (this.showTabs) {
            this.tabs = {
              headers: [{ name: 'Core Skills', totalfeedBackcount: 0, ScoredFeedbackCount: 0 }],
              data: []
            };
            this.subjects = [];
            this.skills = [];
          }
          this.currentVideo = this.userData.demoVideoData.filter((item)=>{
            return item.subject == this.userData.userinfo?.subjects[0]
          })[0]
          if (this.showTabs) {
            this.getSubject();
            this.getSkills();
            await this.avgForSkills();
            await this.avgForSubject();
          }
          this.preloader = false;
          if (this.userData.interViewFeedback == undefined) {
            this.isFeedbackSubmit = false;
          } else {
            this.isFeedbackSubmit = true;
            this.interviewStatus = 'Completed'
            this.step= 1
            this.avgScore = this.userData.interViewFeedback.avgScore
            if (this.showTabs) {
              this.subjects = this.userData.interViewFeedback.subjects
              this.inPersonDemoFeedback = this.userData.interViewFeedback.skills.filter((skill) => skill.skillName === "Inperson Demo")[0]?.feedback || this.inPersonDemoFeedback
            }
          }
        } else {
           alert(data.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    logout() {
      AuthService.logout();
      // this.$router.push("/login");
    },
    openRecomendationFeedbackForm() {      
      let calculatedAvgPercentage = ((this.avgScore / 10) * 100).toFixed(2);
      for (const [_score, _status] of Object.entries(this.recomendationScoreMap)) {
        if(Number(calculatedAvgPercentage) < _score ) {
          this.finalRecommendation = _status
          break
        }
      }
      this.showFullConsentText = false
      this.recommandationFeedbackForm = true

    },
    resetVideoToStart() {
      this.$nextTick(() => {
        if (this.$refs.video && this.$refs.video.currentTime !== undefined) {
          this.$refs.video.currentTime = 0;
        }
      });
    },
    selectVideo(videoData) {
        this.viewVideo = videoData;
        this.videoDialog = true;
        this.resetVideoToStart()
    },
    handleMobileBackClick() {
      if (this.step == 1 && this.userData.interViewFeedback != undefined) {
        this.$router.push('/interviewee-list');
        return;
      }
      this.$router.back();
    },
    openInNewWindow(url = null){
      if(url){
        window.open(url, '_blank');
      }
    },
    onResumeIconClick(url = null) {
      if (!url) return;
      if (this.isMobile) {
        this.downloadResume(url);
      } else {
        this.openInNewWindow(url);
      }
    },
    async downloadResume(url) {
      if (!url || this.resumeDownloading) return;
      const fileName = this.getResumeFileName(url);
      this.resumeDownloading = true;
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        this.resumeDownloadedFileName = fileName;
        this.resumeDownloadSnackbar = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.resumeDownloading = false;
      }
    },
    getResumeFileName(url) {
    if (!url) return '';
    const decoded = decodeURIComponent(url);
    const match = decoded.match(/-([^-\/?]+\.pdf)/i); 
    return match ? match[1] : 'Resume';
  },
  isInterviewActive() {
    const slotDate = new Date(this.slotId); // e.g., '2025-07-02'
    slotDate.setHours(0, 0, 0, 0);
    const now = new Date();
    if (now >= slotDate) return { isActive: true, slotOpenTime: null };
    else {
      return { isActive: !this.isProduction, slotOpenTime:slotDate };
    }
},
  lockBodyScroll() {
    this.savedScrollY = window.scrollY;
    document.body.style.top = `-${this.savedScrollY}px`;
    document.body.classList.add('body-scroll-lock');
  },
  unlockBodyScroll() {
    document.body.classList.remove('body-scroll-lock');
    document.body.style.top = '';
    window.scrollTo(0, this.savedScrollY || 0);
  }

  },
  created() {
  },
  beforeDestroy() {
    if (this.isMobile) {
      this.unlockBodyScroll();
    }
  },
};
</script>
<style scoped>
.color-box{
  height: 10px;
  width: 10px;
  border-radius: 2px;
} 
.range-1{
  background-color: #D40028;
}
.range-2{
  background-color: #FB7500;
}
.range-3{
  background-color: #FADC00;
}
.range-4{
  background-color: #8AD321;
}
.range-5{
  background-color: #1C940F;
}
.fixed-panel{
  position: sticky;
  z-index: 10;
  border-radius: 16px;
}
.bottom-10{
  bottom:10px;
}
.bottom-100{
  bottom:100px
}
.bottom-mobile{
  bottom:68px
}
.top-0{
  top:0px
}

.v-application  .v-expansion-panel-header--active  {
    border-bottom: none !important ;
}
.pos-rel{
  position: relative;
}
.v-application .v-expansion-panel--active {
  border-radius: 16px !important;
}
.v-application .v-expansion-panel {
  background-color: #EBEBFA !important;

}

.not-recommended{
  color: #D40028;
  background-color: #F9DBE1 !important;
}

.below-standard{
  background-color: rgba(251, 117, 0, 0.16);
  color: rgba(251, 117, 0, 1);
}
.moderately-recommended{
  background-color: #FFF4EB !important;
  color: #FB7500;

    }
.highly-recommended{
  color: #06C270;
  background-color: rgba(6, 194, 112, 0.16);
}
.strongly-recommended{
  color: #007C2A;
  background-color: #CBF0E0 !important;
}
  aside {
    min-width: 290px;
    background: var(--white);
  }
  .interview-details-main-container {
    .interview-details-card {
      padding: 12px;
      border: 1px solid var(--gray-03);
      border-radius: 8px;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.25) !important;
      margin-bottom: 20px;
    }
    .interview-details-inner-container {
      gap: 16px;
    }
    
    .interview-rhs-container {
      .v-btn {
        padding: 0 24px !important;
        color: var(--primary);
        background: var(--gray-02);
        border: 1px solid var(--blue-01) !important;
      }
      .v-btn--active {
        color: var(--white);
        background: var(--blue-01);
      }  
    }
  }

.v-list-item__content {
  min-height: 64px;
}

.qpad {
  padding-right: 40px !important;
}
.video-dimensions{
  height: 67px;
  width: 144px;
}
.video-play-section {
  border: 1px solid var(--gray-03);
}
.video-image-wrapper {
  width: 100px;
  height: 68px;
  img {
    width: 100%;
    height: 100%;
  }
}
.interview-score-container {
  .interview-card {
    flex: 1;
  }
  .interview-inner-card {
    background: var(--gray-07);
  }
}
.interview-btn-container {
  gap: 12px;
}

.text-green{
 color: #228B22;
}
.text-orange{
  color: #E49F0A;
}
.interview-demo-card {
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin:20px;
  border: 1px solid var(--gray-03);
  min-height: 280px;
  .view-btn {
    border: 1px solid var(--blue-01) !important;
    margin-top: auto;
  }
  .topic-name {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;  
    overflow: hidden;
  }
}
.page-container {
  height: 100vh;
  /* 100vh on mobile is measured with the browser chrome (address bar) hidden, so the
     real visible viewport is shorter and content pinned to the bottom (e.g. the
     Cancel/Proceed buttons) gets cropped. 100dvh tracks the actual visible viewport;
     kept as a progressive override since older browsers don't support dvh. */
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page-container--mobile-fixed {
  /* height:100dvh + overflow:hidden alone still let the whole page scroll as one
     block on some devices (same issue seen on TestReport's mobile view, cropping its
     footer buttons) — position:fixed removes it from normal document flow entirely,
     which is what actually fixed it there. Scoped to mobile only since .page-container
     is shared with desktop. */
  position: fixed;
  inset: 0;
  height: 100vh;
  height: 100dvh;
  z-index: 1;
}

.mobile-fixed-footer {
  /* Even inside the position:fixed shell above, this row still scrolled out of view
     with the rest of the content on some devices — pinning it directly to the
     viewport bottom guarantees it's always visible regardless of how tall the
     feedback content above it is. */
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--white);
  z-index: 2;
  padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px)) !important;
}

.recommendation-dialog-card {
  padding: 32px;
}
.recommendation-dialog-scroll {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
.recommendation-dialog-scroll::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
}
.recommendation-dialog-actions {
  flex: 0 0 auto;
}
.recordViedoCard {
  background-color: var(--gray-01, #f5f5f5);
  border-radius: 8px;
  word-break: break-word;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.recorded-video-value {
  font-size: 16px;
}
.video-dialog-card {
  padding: 32px;
}
@media (max-width: 959px) {
  .recommendation-dialog-card {
    padding: 16px;
    display: flex;
    flex-direction: column;
    max-height: 85vh;
    overflow: hidden;
  }
  .video-dialog-bottom-sheet {
    align-self: flex-end !important;
    margin: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .video-dialog-card {
    padding: 16px;
    border-radius: 16px 16px 0 0 !important;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
  }
  .recordViedoCard {
    flex-direction: column;
    align-items: flex-start;
  }
  .recorded-video-topic {
    margin-bottom: 12px;
  }
  .recorded-video-value {
    font-size: 14px;
  }
}
.video-dialog-scroll {
  overflow-y: auto;
  overflow-x: hidden;
}
.consent-text-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.checkbox-top-align ::v-deep .v-input--selection-controls__input {
  margin-top: 0;
}
.checkbox-top-align ::v-deep .v-input__slot {
  margin-top: 0;
  align-items: flex-start;
}
.checkbox-label-text {
  padding-top: 3px;
}
.consent-toggle-link {
  color: var(--blue-01);
  cursor: pointer;
  font-weight: 500;
  white-space: nowrap;
}

.top-panel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding-left: 100px;
  box-sizing: border-box;
  height: 100px; /* Adjust height as needed */
  /* Page chrome must stay below 200: Vuetify reserves 200+ for its overlay layer
     (dialogs, menus, overlays). A higher value here left the header painted on top
     of open dialogs. Relative order within this component is preserved. */
  z-index: 30;
}

.mobile-start-interview-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 15;
  padding: 12px 16px;
  background: white;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
}

.scroller{
  overflow-y: scroll; 
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; 
}   



/* For WebKit browsers (Chrome, Safari) */
.scroller::-webkit-scrollbar {
  display: none;
}
.scrollable-content-default {
   margin-top: 116px; /* Should match top-panel height */
   height: calc(100vh - 136px);
}
.mobile-feedback-stack {
   flex-direction: column-reverse;
   margin-top: 64px; /* Should match mobile top-panel height */
   height: calc(100vh - 84px);
   overflow-y: auto;
   gap: 16px;
   scrollbar-width: none; /* Firefox */
   -ms-overflow-style: none; /* IE/Edge */
}
.mobile-feedback-stack::-webkit-scrollbar {
   display: none; /* Chrome/Safari */
}
.mobile-candidate-summary-card {
   background: var(--white);
}
.mobile-candidate-summary-info {
   min-width: 0;
}
.mobile-candidate-nav-btn {
   min-width: auto !important;
   width: 40px;
   height: 36px !important;
   padding: 0 !important;
   flex: 0 0 auto;
   border-radius: 18px 0 0 18px !important;
}
.mobile-candidate-nav-btn.v-btn--outlined {
   border-right: none !important;
}
.mobile-candidate-drawer-backdrop {
   position: fixed;
   inset: 0;
   background: rgba(0, 0, 0, 0.5);
   z-index: 35;
}
.mobile-candidate-drawer {
   position: fixed !important;
   top: 0 !important;
   right: 0;
   left: auto;
   margin-top: 0 !important;
   height: 100vh !important;
   height: 100dvh !important;
   width: 85vw;
   max-width: 360px;
   transform: translateX(100%);
   transition: transform 0.25s ease;
   z-index: 36;
   overflow: hidden;
   background: var(--white);
   display: flex !important;
   flex-direction: column;
}
.mobile-candidate-drawer--open {
   transform: translateX(0);
}
.mobile-candidate-drawer .pos-rel {
   display: flex;
   flex-direction: column;
   flex: 1 1 auto;
   min-height: 0;
}
.mobile-candidate-drawer .fixed-panel {
   position: static !important;
   flex: 0 0 auto;
}
.mobile-candidate-drawer .scroller {
   flex: 1 1 auto;
   min-height: 0;
   height: auto !important;
   overflow-y: auto;
   overscroll-behavior: contain;
}
.mobile-stacked-panel {
   margin-top: 0 !important;
   height: auto !important;
   flex: 0 0 auto;
}
.mobile-full-width-card {
   width: 100%;
}
.mobile-top-panel-offset {
   margin-top: 64px !important;
   height: calc(100vh - 84px) !important;
}
.mobile-stacked-panel .scroller,
.mobile-stacked-panel.scroller {
   height: auto !important;
   overflow: visible !important;
}
.mobile-stacked-panel .fixed-panel {
   position: static !important;
}
.interview-feedback-success-icon {
   width: 100px;
   height: auto;
   flex-shrink: 0;
}
.scrollable-content-active {
   margin-top: 80px; /* Should match top-panel height */
   height: calc(100vh - 185px);
}
.aside-scrollable-active-2 {
   margin-top: 80px;
   height: calc(100vh - 182px);
}
.aside-scrollable-active {
   margin-top: 116px;
   height: calc(100vh - 131px);
}
.interview-only-card {
  gap: 16px;
  padding: 24px;
}
.interview-only-banner{
  width: min(100%, 520px);
  height: clamp(180px, 70vh, 400px) !important;
  flex: 0 0 auto;
}
.mt-minus{
  margin-top: -8px;
}
.mid-scroll-2-new{
 height: calc(100vh - 343px);
}

.mid-scroll-1-new{
 height: calc(100vh - 425px);
}
.mid-scroll-1{
     height: calc(100vh - 390px); 
}

.mid-scroll-2{
     height: calc(100vh - 290px);
}
.mid-scroll-1-mobile{
     height: calc(100vh - 408px);
}
.mid-scroll-2-mobile{
     height: calc(100vh - 308px);
}
.video-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  color: #888;
  border: 2px dashed #ccc;
}
.resumeContainer{
  border: 1px solid var(--gray-03);
  border-radius: 5px;
  padding: 8px;
  margin-bottom: 16px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);

}
.resumeBox {
  display: flex;
  justify-content:space-between;
  align-items: center;
}
.resume-file-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.interview-feedback-subtitle{
  font-family: "GraphikMedium", sans-serif !important;
  font-size: 20px;
  font-weight: 500;
}
</style>
